import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { CommodityDetail } from "features/contracts/enums/commodityDetail"

export const getCommodityIcon = (commodityDetail?: CommodityDetail): IconProp => {
  switch (commodityDetail) {
    case CommodityDetail.ElectricityCustomer:
    case CommodityDetail.ElectricitySupplier:
      return "bolt";
    case CommodityDetail.GasCustomer:
    case CommodityDetail.GasSupplier:
      return "fire";
    case CommodityDetail.HeatCustomer:
      return "thermometer-three-quarters";
    case CommodityDetail.eMobility:
      return "charging-station";
    default:
      return "file-alt";
  }
}
